<!--  -->
<template>
  <div class="ToTop" @click="backToTop">
    <img src="https://oss.sbooip.com/static/www/pc/assets/images/top.png" alt="">
  </div>
</template>

<script>
export default {
  name: "ToTop",
  components: {},
    data() {
      return {

      };
    },
  methods: {
    backToTop() {
      window.scrollTo(0, 0)
    }
  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
  .ToTop{
    cursor: pointer;
    position: fixed;
    right: 400px;
    bottom:  200px;
    z-index: 9999;
    img{
     width: 50px;
    }
  }
</style>